module.exports = __webpack_public_path__ + "static/media/mouth_green_light.7f7af93e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/mouth_green_light.svg
// module id = 357
// module chunks = 0